import React from "react";

/**
 * Simple pager for Laravel pagination payloads
 * (current_page, last_page, total, from, to).
 */
const Pagination = ({
    currentPage = 1,
    lastPage = 1,
    total = 0,
    from = null,
    to = null,
    disabled = false,
    onPageChange,
}) => {
    if (!total || lastPage <= 1) {
        return null;
    }

    const goTo = (page) => {
        if (disabled || page < 1 || page > lastPage || page === currentPage) {
            return;
        }
        onPageChange(page);
    };

    return (
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3">
            <small className="text-muted mb-2 mb-md-0">
                Mostrando {from ?? '-'}–{to ?? '-'} de {total}
            </small>
            <div className="btn-group" role="group" aria-label="Paginación">
                <button
                    type="button"
                    className="btn btn-outline-dark"
                    disabled={disabled || currentPage <= 1}
                    onClick={() => goTo(currentPage - 1)}
                >
                    Anterior
                </button>
                <button type="button" className="btn btn-outline-dark" disabled>
                    {currentPage} / {lastPage}
                </button>
                <button
                    type="button"
                    className="btn btn-outline-dark"
                    disabled={disabled || currentPage >= lastPage}
                    onClick={() => goTo(currentPage + 1)}
                >
                    Siguiente
                </button>
            </div>
        </div>
    );
};

export default Pagination;
